import { createAction, handleActions } from "redux-actions";
import { takeLatest } from "redux-saga/effects";
import createRequestSaga, {
  createRequestActionTypes,
} from "./lib/createRequestSaga";
import * as termTemplatesAPI from "../api/termTemplates";
import {
  currentPageNumberProps,
  filterItemProps,
  GetPayload,
  PaginationItemProps,
} from "../types/commons";
import {
  termTemplatesState,
  listTermTemplatesProps,
} from "../types/termTemplates";

const INITIALIZE = "termsTemplatesList/INITIALIZE";
const SET_TERM_LIST_CURRENT_PAGE_NUMBER =
  "termsTemplatesList/SET_TERMS_LIST_CURRENT_PAGE_NUMBER" as const;
const SET_TERM_PAGINATION_ITEM =
  "termsTemplatesList/SET_TERMS_PAGINATION_ITEM" as const;
const SET_TERM_FILTER_ITEM =
  "termsTemplatesList/SET_TERMS_FILTER_ITEM" as const;
const SET_TERM_INIT_FILTER_ITEM =
  "termsTemplatesList/SET_TERMS_INIT_FILTER_ITEM" as const;
const SET_TERM_DETAIL = "termsTemplatesList/SET_TERMS_DETAIL" as const;

//리덕스 모듈에서 API를 사용할 수 있게 추가
const [TERM_LIST, TERM_LIST_SUCCESS, TERM_LIST_FAILURE] =
  createRequestActionTypes("termsTemplatesList/TERM_LIST");

/* action */
export const initialize = createAction(INITIALIZE);
// 약관 목록 조회 시도
export const listTermTemplatesAction = createAction(
  TERM_LIST,
  ({ hotel_id, title, offset, limit, pagination }: listTermTemplatesProps) => ({
    hotel_id,
    title,
    offset,
    limit,
    pagination,
  }),
);
export const setCurrentPageNumberAction = createAction(
  SET_TERM_LIST_CURRENT_PAGE_NUMBER,
  ({ currentPageNumber }: currentPageNumberProps) => ({
    currentPageNumber,
  }),
);
export const setPaginationItemAction = createAction(
  SET_TERM_PAGINATION_ITEM,
  ({ paginationItem }: PaginationItemProps) => paginationItem,
);
export const setFilterItemAction = createAction(
  SET_TERM_FILTER_ITEM,
  (filterItem: filterItemProps) => ({
    filterItem,
  }),
);

export const setDetailField = createAction(SET_TERM_DETAIL, (id: number) => ({
  id,
}));
export const setInitFilterItemAction = createAction(SET_TERM_INIT_FILTER_ITEM);

//사가 생성
const listTermSaga = createRequestSaga(
  TERM_LIST,
  termTemplatesAPI.listTermTemplate,
);

export function* termTemplatesListSaga() {
  yield takeLatest(TERM_LIST, listTermSaga);
}

//initialState
const initialState: termTemplatesState = {
  termTemplatesTotal: 0,
  termTemplatesItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 50,
  },
  filterItem: {
    title: "",
  },
  termTemplatesError: null,
  detailField: {
    id: 0,
  }, //detail로 진입 시 저장
};

// 페이로드를 가져오기 위한 헬퍼 타입
type Payloads = GetPayload<
  | typeof initialize
  | typeof listTermTemplatesAction
  | typeof setCurrentPageNumberAction
  | typeof setPaginationItemAction
  | typeof setFilterItemAction
  | typeof setDetailField
  | typeof setInitFilterItemAction
>;

const termTempatesList = handleActions<termTemplatesState, Payloads>(
  {
    [INITIALIZE]: (state) => initialState, // initialState를 넣으면 초기 상태로 바뀜
    // 약관 목록 조회 성공
    [TERM_LIST_SUCCESS]: (state, { payload: { total, items } }) => ({
      ...state,
      termTemplatesTotal: total,
      termTemplatesItems: items,
      termTemplatesError: null,
    }),
    // 약관 목록 조회 실패
    [TERM_LIST_FAILURE]: (state, { payload: error }) => ({
      ...state,
      termTemplatesError: error,
    }),
    // 약관 현재 페이지
    [SET_TERM_LIST_CURRENT_PAGE_NUMBER]: (
      state,
      { payload: { currentPageNumber } },
    ) => ({
      ...state,
      currentPageNumber: currentPageNumber,
    }),
    // 약관 페이지네이션
    [SET_TERM_PAGINATION_ITEM]: (state, { payload: paginationItem }) => ({
      ...state,
      paginationItem: paginationItem,
    }),
    // 약관 필터
    [SET_TERM_FILTER_ITEM]: (state, { payload: filter }) => ({
      ...state,
      filterItem: filter.filterItem,
    }),
    // 약관 초기화
    [SET_TERM_INIT_FILTER_ITEM]: (state) => ({
      ...state,
      filterItem: {
        title: "",
      },
    }),
    // detail 접근 시 필드 저장
    [SET_TERM_DETAIL]: (state, { payload: detailField }) => ({
      ...state,
      detailField: {
        id: detailField.id,
      },
    }),
  },
  initialState,
);

export default termTempatesList;
